import 'react-mde/lib/styles/css/react-mde-all.css';
import { BASE_URL } from '@synergy/config';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';

import { NotFound } from './features/not-found/not-found';
import { OPEN_INQUIRIES, PaloAppLayout } from './palo-app-layout';
import { Offers } from './features/offers/offers';
import { PaloInquiriesOverview } from './features/inquiry/palo/palo-inquiries-overview';
import { ROUTES } from './features/sidebar-menu/navigation-drawer/routes';
import { protectedComponents as pc } from './protected-components';

const router = createBrowserRouter(
    [
        {
            element: <PaloAppLayout />,
            children: [
                { path: ROUTES.inquires, element: <PaloInquiriesOverview /> },
                { path: ROUTES.inquires + '/:id', element: <Offers /> },
                { path: ROUTES.purchases, element: <pc.PurchaseOrders /> },
                { path: ROUTES.userManagement, element: <pc.UserManagement /> },
                { path: ROUTES.notifications, element: <pc.Notification /> },
                { path: ROUTES.bonusSettlements.overview, element: <pc.BonusSettlementOverviewRestricted /> },
                { path: ROUTES.bonusSettlements.detail, element: <pc.BonusSettlementDetailRestricted /> },
                { path: ROUTES.notFound, element: <NotFound /> },
            ],
        },
        { path: '*', element: <Navigate to={OPEN_INQUIRIES} /> },
    ],
    { basename: BASE_URL || '/' }
);

export const AppRouter = () => <RouterProvider router={router} />;
